import React, { useState } from 'react';
import { useRouter } from 'next/router';
import SearchFilter from 'components/pld/shared/filters/SearchFilter';
import Icons from 'components/atoms/Icons';

type GlobalSearchBarProps = {
  onClose?: () => void;
};

const GlobalSearchBar = ({ onClose }: GlobalSearchBarProps): React.JSX.Element => {
  const [query, setQuery] = useState('');
  const router = useRouter();

  const onQueryInputChange = (value: string) => setQuery(value);
  const submitSearch = (value: string) => {
    if (value.trim().length === 0) return;
    router.push(`/search?query=${encodeURIComponent(value)}`);
    onClose?.();
  };

  return (
    <div className="global-search-bar">
      <div className="global-search-field-group">
        <SearchFilter
          minimumCharacters={2}
          onQueryInputChange={onQueryInputChange}
          placeholder="Search"
          queryInputValue={query}
          searchType="global"
          updateQuery={submitSearch}
        />
        <button
          type="button"
          className="global-search-submit"
          aria-label="Submit search"
          onClick={() => submitSearch(query)}
        >
          <Icons id="arrow-go" />
        </button>
      </div>
    </div>
  );
};

export default GlobalSearchBar;